// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bPopularProductsTitle{text-align:center;font-size:46px;font-family:\"openSansRegular\",\"serif\";margin:30px 0 20px}", ""]);
// Exports
module.exports = exports;
